import { render, staticRenderFns } from "./PlatformPreview.vue?vue&type=template&id=68c64430&scoped=true"
import script from "./PlatformPreview.vue?vue&type=script&lang=js"
export * from "./PlatformPreview.vue?vue&type=script&lang=js"
import style0 from "./PlatformPreview.vue?vue&type=style&index=0&id=68c64430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c64430",
  null
  
)

export default component.exports